import React from "react";
import { Box, makeStyles, Typography, useTheme } from "@material-ui/core";

import { DEVICE_STATUS } from "../../domain/device";
import I18nText from "../../elements/I18nText";
import { DisregardIcon, SeenIcon } from "../../elements/Icon";
import { alpha } from "@material-ui/core/styles";

const DeviceStatus = ({ device }) => {
  const theme = useTheme();

  const classes = makeStyles(theme => ({
    statusText: {
      display: "inline-block",
      fontSize: "0.65rem",
      borderRadius: 4,
      fontWeight: "900",
      padding: "4px 8px",
      textTransform: "capitalize"
    },
    ok: {
      backgroundColor: alpha(theme.custom.colors.deviceStatus.ok, 0.1),
      color: theme.custom.colors.deviceStatus.ok
    },
    alarm: {
      display: "inline-block",
      fontSize: "0.65rem",
      backgroundColor: alpha(theme.custom.colors.deviceStatus.alarm, 0.1),
      borderRadius: 4,
      fontWeight: 900,
      padding: "4px 8px",
      color: theme.custom.colors.deviceStatus.alarm,
      textTransform: "capitalize"
    },
    warning: {
      backgroundColor: alpha(theme.custom.colors.deviceStatus.warning, 0.1),
      color: theme.custom.colors.deviceStatus.warning
    },
    error: {
      backgroundColor: alpha(theme.custom.colors.deviceStatus.error, 0.1),
      color: theme.custom.colors.deviceStatus.error
    }
  }))();

  if (device.status === DEVICE_STATUS.ALARM) {
    const statuses = [];

    device.alarms.forEach(alarm => {
      if (!alarm.confirmationStatus) {
        statuses.push(DEVICE_STATUS.ALARM);

        return;
      }

      statuses.push(alarm.confirmationStatus);
    });

    if (statuses.indexOf(DEVICE_STATUS.ALARM) !== -1) {
      return (
        <Typography className={classes.alarm}>
          <I18nText>devices.common.statuses.alarm</I18nText>
        </Typography>
      );
    }

    if (statuses.indexOf("seen") !== -1) {
      return <SeenIcon />;
    }

    if (statuses.indexOf("disregard") !== -1) {
      return <DisregardIcon />;
    }
  }

  if (device.thresholdStatus) {
    if (device.thresholdConfirmationStatus === "seen") {
      return (
        <Box
          color={
            device.active ? theme.palette.warning.main : theme.palette.grey.A200
          }
        >
          <SeenIcon />
        </Box>
      );
    }

    if (device.thresholdConfirmationStatus === "disregard") {
      return (
        <Box
          color={
            device.active ? theme.palette.warning.main : theme.palette.grey.A200
          }
        >
          <DisregardIcon />
        </Box>
      );
    }

    return (
      <Box className={classes.alarm}>
        <I18nText>devices.list.table.statuses.threshold</I18nText>
      </Box>
    );
  }

  return (
    <Box className={`${classes.statusText} ${classes[device.status]}`}>
      <I18nText>{`devices.common.statuses.${device.status}`}</I18nText>
    </Box>
  );
};

export default DeviceStatus;
